import { AxiosResponse } from 'axios';
import { getAxiosSecureInstance } from '../../utilities/AxiosClient';

export function getFile(fileId: string): Promise<AxiosResponse> {
  const axios = getAxiosSecureInstance();
  return axios.request({
    responseType: 'arraybuffer',
    url: `/api/form/file/${fileId}`,
    method: 'get',
  });
}
